'use strict';

let $ = require('jquery'),
    JsZipComplete = {},
    JSONDATA = 'https://yubinbango.github.io/yubinbango-data/data/';

JsZipComplete.jpZipCache = {};
JsZipComplete.currentZip = null;
JsZipComplete.prefectionName = null;
JsZipComplete.cityName = null;
JsZipComplete.zipStart = null;

window.$yubin = function (data) {
    let dataArray, opera, prefectionID, city;

    JsZipComplete.jpZipCache[JsZipComplete.zipStart] = data;

    dataArray = data[JsZipComplete.currentZip];
    opera = JsZipComplete.currentZip - 0 + 0xff000000 + '';

    if (!dataArray && data[opera]) {
        dataArray = data[opera];
    }

    if (!dataArray) {
        return;
    }

    prefectionID = 'pref-' + ('0' + dataArray[0]).slice(-2);
    city = dataArray[1] + dataArray[2] + (dataArray[3] ? dataArray[3] : '');

    $('[name="' + JsZipComplete.prefectionName + '"]')
        .val(prefectionID)
        .trigger('change');
    $('[name="' + JsZipComplete.cityName + '"]')
        .val(city)
        .trigger('blur');
};

function adjustZip(zip) {
    let adjustedZip = '',
        currentCharCode,
        i;

    for (i = 0; i < zip.length; i++) {
        currentCharCode = zip.charCodeAt(i);

        if (currentCharCode < 48 || currentCharCode > 57) {
            continue;
        }

        adjustedZip += zip.charAt(i);
    }

    return adjustedZip;
}

function complete(zip, prefectionName, cityName) {
    let zipStart = zip.substr(0, 3),
        data = JsZipComplete.jpZipCache[zipStart];

    JsZipComplete.prefectionName = prefectionName;
    JsZipComplete.cityName = cityName;
    JsZipComplete.zipStart = zipStart;
    JsZipComplete.currentZip = zip;

    if (data) {
        $yubin(data);
    } else {
        $.getScript(JSONDATA + zipStart + '.js');
    }
}

module.exports = function ($postalCode) {
    // On 'change' event, add the hyphen - Avoid japanese keyboard bug BSDDEV-10520
    $postalCode.on('change', function () {
        let rawZip = $postalCode.val();

        if (rawZip.length === 7 && rawZip.charAt(3) !== '-') {
            rawZip = rawZip.slice(0, 3) + '-' + rawZip.slice(3);
            $postalCode.val(rawZip);
        }
    });

    // On 'input' event, call the 'complete' function and auto-fill the fields
    $postalCode.on('input', function () {
        let zip = adjustZip($postalCode.val());
        if (zip.length === 7) {
            complete(zip, $postalCode.data('jpzipcomplete-htmlname'), $postalCode.data('jpzipcomplete-cityhtmlname'));
        }
    });
};
